import type { Dispatch, SetStateAction } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faComment, faSync } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, HoverHintWrapper,
} from '@domain-group/suit-theme'

import useConversationContainer from '@hooks/useConversationContainer'

import type { AdCopyModel } from '@models/types'

interface AdCopyItemHeaderProps {
  adCopy: Partial<AdCopyModel>,
  campaignId: number,
  commentsCallback?: (() => void) | Dispatch<SetStateAction<any>>,
}

const AdCopyItemHeader = (props: AdCopyItemHeaderProps) => {
  const {
    adCopy, campaignId, commentsCallback,
  } = props

  const conversationPayload = useConversationContainer({
    conversation: {
      // @ts-expect-error TS2322
      subject_id: adCopy.id,
      subject_type: 'AdCopy',
    },
    performHttpRequests: !!adCopy.id && !!campaignId,
    requestOptions: {
      include_conversation_comments: true,
    },
  })

  const { filteredComments } = conversationPayload
  const hasComments = filteredComments?.length > 0

  const isApproved = adCopy?.review_status === 'approved'
  const isAddedToCampaign = adCopy?.copied_to_campaign

  return (
    <Box justifyContent="flex-end">
      {isApproved && (
        <HoverHintWrapper
          hintComponent={<HoverHintWrapper.Hint>Approved</HoverHintWrapper.Hint>}
        >
          <Button
            buttonStyle="primaryCreate"
            icon={<FontAwesomeIcon icon={faCheck} />}
            //@ts-expect-error
            marginY="auto"
            marginLeft="medium"
            padding="small"
            width="fit-content"
          />
        </HoverHintWrapper>
      )}

      {isAddedToCampaign && (
        <HoverHintWrapper
          hintComponent={<HoverHintWrapper.Hint>Added To Campaign</HoverHintWrapper.Hint>}
        >
          <Button
            buttonStyle="primaryEdit"
            icon={<FontAwesomeIcon icon={faSync} />}
            //@ts-expect-error
            marginY="auto"
            marginLeft="medium"
            padding="small"
            width="fit-content"
          />
        </HoverHintWrapper>
      )}

      {(hasComments && !isAddedToCampaign && !isApproved) && (
        <HoverHintWrapper
          hintComponent={commentsCallback && (
            <HoverHintWrapper.Hint>Show/Hide Comments</HoverHintWrapper.Hint>
          )}
        >
          <Button
            buttonStyle="primaryEdit"
            icon={<FontAwesomeIcon icon={faComment} />}
            marginY="auto"
            marginLeft="medium"
            // @ts-expect-error TS2322
            onClick={commentsCallback || (() => {})}
            padding="small"
            style={{
              backgroundColor: '#e78d2d',
              borderColor: '#e78d2d',
              fontSize: '10px',
            }}
            width="fit-content"
          >
            {filteredComments.length}
          </Button>
        </HoverHintWrapper>
      )}
    </Box>
  )
}

export default AdCopyItemHeader
